import { sortCustomersByField } from '../../actions';

export const customerListDropdownOptions = {
    placeholder: 'מיין',
    mainContent: null,
    setDisplayedData: null,
    data: [
        {
            label: 'ע״פ א ב',
            action: null
        },
        {
            label: 'ע״פ סדר נסיעה',
            action: null
        }
    ],
    setup(mainContentRef, setDisplayedDataRef) {
        this.mainContent = mainContentRef;
        this.setDisplayedData = setDisplayedDataRef;
        this.data[0].action = () => {
            const sortedData = sortCustomersByField(this.mainContent, 'agent');
            this.setDisplayedData(sortedData);
        };

        this.data[1].action = () => {
            console.log('clicked!'); // add logic func here :)
        };
    }
};
